const validateCamposErpSeniorTeixeira = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Armazém é obrigatório'];
  }
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta contábil é obrigatória'];
  }
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'Conta financeira é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Armazém é obrigatório'];
  }
  if (!camposIntegracao.contaContabil) {
    return [false, 'Conta contábil é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSenior = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Depósito é obrigatório'];
  }
  return [true, null];
};

export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === 'TOTVS') {
    return validateCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === 'SENIOR') {
    return validateCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return validateCamposErpSeniorTeixeira(camposIntegracao);
  }
  return [true, null];
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === 'TOTVS') {
    return {
      armazem: null,
      contaContabil: null,
    };
  }
  if (tipoErp === 'SENIOR') {
    return {
      armazem: null,
    };
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return {
      armazem: null,
      contaContabil: null,
      contaFinanceira: null,
    };
  }
  return {};
};
